import { ScrollText, Download, FileText } from "lucide-react";
import { Reveal } from "./Reveal";

const CONSTITUTION_PDF = "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/f86ob44k_iJHXgZoBQM.pdf";

export const Constitution = () => (
  <section id="constitution" className="relative py-28 sec-constitution overflow-hidden" data-testid="constitution-section">
    <div className="absolute top-20 right-0 w-[400px] h-[400px] rounded-full bg-yellow-400/5 blur-[120px]" />
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="grid lg:grid-cols-[1.2fr_1fr] gap-14 items-center">
        <Reveal>
          <div className="flex items-center gap-4 mb-4">
            <ScrollText className="text-yellow-400 shrink-0" size={22} />
            <p className="eyebrow">Official Document • Our Principles • Our Commitment</p>
          </div>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Constitution <span className="text-yellow-400">of the RGP</span>
          </h2>
          <p className="mt-6 max-w-xl text-zinc-400 leading-relaxed">
            Our Constitution defines the values, principles and responsibilities that
            guide every RGP member.
          </p>
          <p className="mt-3 max-w-xl text-zinc-400 leading-relaxed">
            It is our commitment to the people of Goa, democratic values,
            accountability and the interests of Goa.
          </p>
          <a
            data-testid="constitution-download-button"
            href={CONSTITUTION_PDF}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-yellow mt-8"
          >
            <Download size={18} /> Download the Constitution (PDF)
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <a
            data-testid="constitution-document-card"
            href={CONSTITUTION_PDF}
            target="_blank"
            rel="noopener noreferrer"
            className="agenda-card p-10 flex flex-col items-center text-center group cursor-pointer block"
          >
            <div className="bg-yellow-400/10 p-6 group-hover:bg-yellow-400 transition-colors">
              <FileText size={48} className="text-yellow-400 group-hover:text-black transition-colors" />
            </div>
            <h3 className="mt-6 font-display font-bold uppercase text-2xl text-white">
              Constitution of the<br />Revolutionary Goans Party
            </h3>
            <p className="mt-2 font-mono-rgp text-[10px] uppercase tracking-[0.25em] text-yellow-400">
              Official Document · PDF
            </p>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
